const { date } = require('./date')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {*} value
 * @param {boolean} validationValue
 * @returns {boolean}
 */
function pastDate ({ value, validationValue }) {
  if (!validationValue) return true
  if (!date({ value, validationValue })) return false

  const now = new Date()
  const currentYear = now.getFullYear()
  const currentMonth = now.getMonth() + 1
  const year = parseInt(value?.year, 10)
  const month = parseInt(value?.month, 10)

  /* istanbul ignore next */
  return year < currentYear || (year === currentYear && month <= currentMonth)
}

module.exports = { pastDate }
